<template>
  <div
    v-if="isShow"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="dialogTitle"
      class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white"
    >
      <h3
        id="dialogTitle"
        class="ml-6 mt-7 mb-5"
      >
        {{ $t('messages.entra_trouble.title') }}
      </h3>
      <p class="ml-6 mr-6 mb-10 text-zyxel-gray-800">
        {{ $t('messages.entra_trouble.unauth_description') }}
      </p>
      <div class="flex px-4 sm:px-0 sm:justify-end sm:space-x-2 sm:mr-6 mb-9">
        <button
          ref="okButton"
          class="w-full sm:w-auto sm:min-w-[120px] button-primary"
          @click="close"
        >
          {{ $t('messages.button.ok') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EntraUnauthDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    isShow(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.okButton.focus();
        });
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }
}
</script>